import { AppSidebar } from "@/components/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { navItems } from "@/lib/nav-items";
import { Separator } from "@/components/ui/separator";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Link, router, usePage } from "@inertiajs/react";
import { ThemeProvider } from "next-themes";
import { NuqsAdapter } from "nuqs/adapters/react";
import { useEffect } from "react";
import { toast } from "sonner";

export default function AppLayout({ children }: React.PropsWithChildren) {
  const { user } = usePage().props;

  useEffect(() => {
    const removeListener = router.on("flash", (event) => {
      if (event.detail.flash.alert) {
        toast.error(event.detail.flash.alert);
      }
      if (event.detail.flash.notice) {
        toast.info(event.detail.flash.notice);
      }
    });

    // Remove the listener
    return removeListener;
  }, []);

  return (
    <>
      <ThemeProvider
        attribute="class"
        defaultTheme={user?.theme ?? "system"}
        enableSystem
        disableTransitionOnChange
      >
        <NuqsAdapter>
          <TooltipProvider>
            <SidebarProvider>
              <AppSidebar />
              <SidebarInset>
                <header className="flex h-16 shrink-0 items-center gap-2">
                  <div className="flex items-center gap-2 px-4">
                    <SidebarTrigger className="-ml-1" />
                    <Separator
                      orientation="vertical"
                      className="mr-2 data-[orientation=vertical]:h-4"
                    />
                    <Breadcrumbs />
                  </div>
                </header>
                <main className="flex flex-1 flex-col gap-4 p-4 pt-0 min-h-0 @container/main">
                  {children}
                </main>
              </SidebarInset>
            </SidebarProvider>
          </TooltipProvider>
          <Toaster />
        </NuqsAdapter>
      </ThemeProvider>
    </>
  );
}

function Breadcrumbs() {
  const { url } = usePage();
  const pathname = url.split("?")[0];

  const activeNav = navItems.find(
    (item) => pathname === item.path || pathname.startsWith(item.path + "/"),
  );

  const segments = pathname.replace("/app/", "").split("/");
  const isChildPage = activeNav && segments.length > 1;

  return (
    <Breadcrumb>
      <BreadcrumbList>
        {activeNav ? (
          <>
            {isChildPage ? (
              <>
                <BreadcrumbItem className="hidden md:block">
                  <BreadcrumbLink asChild>
                    <Link href={activeNav.path}>{activeNav.title}</Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator className="hidden md:block" />
                <BreadcrumbItem>
                  <BreadcrumbPage>#{segments[1]}</BreadcrumbPage>
                </BreadcrumbItem>
              </>
            ) : (
              <BreadcrumbItem>
                <BreadcrumbPage>{activeNav.title}</BreadcrumbPage>
              </BreadcrumbItem>
            )}
          </>
        ) : (
          <BreadcrumbItem>
            <BreadcrumbPage>Início</BreadcrumbPage>
          </BreadcrumbItem>
        )}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
